import api from '../api'
export default {
	namespaced: true,
	state: {
		orgList: []
	},
	mutations: {
		GET_ORG_LIST( state, data = {} ) {
			state.orgList = data.records;
		}
	},
	actions: {
		GET_ORG_LIST( { commit, dispatch },  { all, flag, keyword, pageNum, pageSize } = {} ) {
			let data = all ? {} : { pageNum: 1, pageSize: 10 }
	        // 判断是否需要添加参数
	        if (flag) data.moduleFlag = flag
	        if (keyword) data.keywords = keyword
	        if (pageNum) data.pageNum = pageNum
	        if (pageSize) data.pageSize = pageSize

			return api.orgList( { data } ).then(( res ) => {
				commit( 'GET_ORG_LIST', res.payload )
				return res
			}).catch(( rej ) => {
				window.myVue.$message.error( rej.message )
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/orgManage/store/index.js